
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiFolderCheckOutline,
	mdiAccountWrench,
	mdiAccountDetails,
	mdiViewDashboard,
	mdiAvTimer,
	mdiAccountAlert,
	mdiBusDoubleDecker,
	mdiCalendar,
	mdiSoccer,
	mdiQrcodeScan,
	mdiAccountSchool,
	mdiCog,
	mdiAccount,
	mdiSchool,
	mdiBookshelf,
	mdiCashMultiple,
	mdiAccountChild,
	mdiDoorOpen,
	mdiAccountOutline,
	mdiAccountCircle,
	mdiBookOpenVariant,
	mdiFaceAgent,
	mdiAccountGroup,
	mdiClipboardAccount,
	mdiClipboardAccountOutline,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
	mdiTimetable,
	mdiCalendarMonth,
	mdiBookOpenPageVariant,
	mdiHammerScrewdriver,
	mdiBookPlusMultiple,
	mdiFormatLetterMatches,
	mdiFormatListBulletedType,
	mdiNotebookEdit,
	mdiNumeric9BoxMultiple,
	mdiTimelineClockOutline,
	mdiWatermark,
	// mdiAccountMultiplePlus,
	mdiPen,
	mdiChartBar
} from '@mdi/js'

const menuAcademicAll = [
			{
				to: '/academic-dashboard',
				icon: mdiViewDashboard,
				label: 'sidebar.dashboard'
			},
			{
				label: 'Candidates',
				subLabel: 'Submenus Candidates',
				icon: mdiAccountChild,
				menu: [
					{
						to: '/new-batch-registration',
						label: 'New Batch Registration',
						icon: mdiDoorOpen
					},
					{
						to: '/candidates-group',
						label: 'Candidates Group',
						icon: mdiAccountOutline
					},
					{
						to: '/candidate',
						label: 'Candidate',
						icon: mdiAccountOutline
					}
					// {
					// 	to: '/candidates-placement',
					// 	label: 'Candidates Placement',
					// 	icon: mdiAccountOutline
					// }
				]
			},
			{
				label: 'Student',
				subLabel: 'Submenus Student',
				icon: mdiAccountCircle,
				menu: [
					{
						to: '/students',
						label: 'Students',
						icon: mdiAccountGroup
					},
					// {
					// 	to: '/class-transfer',
					// 	label: 'Class Transfer',
					// 	icon: mdiAccountMultiplePlus
					// },
					{
						to: '/student-resignation',
						label: 'Resignation',
						icon: mdiAccountGroup
					},
					{
						to: '/graduation',
						label: 'Graduation',
						icon: mdiAccountSchool
					}
				]
			},
			{
				label: 'Parents',
				to: '/parent-user',
				icon: mdiAccount
			},
			{
				label: 'Employee',
				subLabel: 'Employee',
				icon: mdiAccountCircle,
				menu: [
					{
						to: '/employee',
						label: 'Employees',
						icon: mdiAccount
					}
				]
			},
			{
				label: 'Subject',
				subLabel: 'Submenus Subject',
				icon: mdiBookOpenVariant,
				menu: [
					{
						to: '/subject',
						label: 'Subject',
						icon: mdiBookshelf
					},
					{
						to: '/subject-group',
						label: 'Subject Group',
						icon: mdiBookOpenPageVariant
					},
					{
						to: '/learning-method',
						label: 'Learning Method',
						icon: mdiBookPlusMultiple
					},
					{
						to: '/grading-aspects',
						label: 'Grading Aspects',
						icon: mdiHammerScrewdriver
					},
					{
						to: '/assignment-type',
						label: 'Assignment Type',
						icon: mdiFormatListBulletedType
					},
					{
						to: '/grading-rule',
						label: 'Grading Rule',
						icon: mdiFormatLetterMatches
					},
					{
						to: '/final-score-rule',
						label: 'Final Score Rule',
						icon: mdiNumeric9BoxMultiple
					},
					{
						to: '/scoreminimum',
						label: 'Passing Grade',
						icon: mdiNumeric9BoxMultiple
					},
					{
						to: '/syllabus',
						label: 'Syllabus',
						icon: mdiNotebookEdit
					},
					{
						to: '/student-paralel-subject',
						label: 'Student Parallel Subject',
						icon: mdiAccountDetails
					},
					{
						to: '/student-select-subject',
						label: 'Student Subject Selection',
						icon: mdiAccountDetails
					}
				]
			},
			{
				label: 'Extracuricular',
				subLabel: 'Submenus Extracuricular',
				icon: mdiSoccer,
				menu: [
					{
						to: '/extracuricular',
						label: 'Extracuricular',
						icon: mdiSoccer
					},
					{
						to: '/extracuricular-group',
						label: 'Extracuricular Group',
						icon: mdiSoccer
					},
					{
						to: '/extracuricular-student',
						label: 'Student Extracuricular',
						icon: mdiAccountDetails
					},
					{
						to: '/extracuricular-student-select',
						label: 'Student Extracuricular Selection',
						icon: mdiAccountDetails
					}
				]
			},
			{
				label: 'Teacher',
				subLabel: 'Submenus Teacher',
				icon: mdiClipboardAccount,
				menu: [
					{
						to: '/teacher',
						label: 'Teacher',
						icon: mdiClipboardAccountOutline
					},
					{
						to: '/teacher-extracuricular',
						label: 'Extracurricular Teacher',
						icon: mdiSoccer
					},
					{
						to: '/scan-asset',
						label: 'Scan Asset',
						icon: mdiQrcodeScan
					},
					{
						to: '/scan-asset-location',
						label: 'Scan Asset Location',
						icon: mdiQrcodeScan
					}
				]
			},
			{
				label: 'Roles',
				subLabel: 'Roles',
				icon: mdiFaceAgent,
				menu: [
					{
						to: '/role',
						label: 'Role',
						icon: mdiFaceAgent
					},
					{
						to: '/role-group',
						label: 'Role Group',
						icon: mdiFaceAgent
					}
				]
			},
			{
				label: 'Transaction',
				subLabel: 'Transaction',
				icon: mdiCashMultiple,
				menu: [
					{
						to: '/transaction-type',
						label: 'Transaction Type',
						icon: mdiCashMultiple
					},
					{
						to: '/transaction-group',
						label: 'Transaction Group',
						icon: mdiCashMultiple
					}
				]
			},
			{
				label: 'Permission Request',
				subLabel: 'Submenus Teacher',
				icon: mdiFaceAgent,
				menu: [
					{
						to: '/permissions',
						label: 'Permissions',
						icon: mdiFaceAgent
					},
         			{
						to: '/permission-reason',
						label: 'Permission Reason',
						icon: mdiFaceAgent
					}
				]
			},
			{
				label: 'Schedule',
				subLabel: 'Submenus Schedule',
				icon: mdiTimetable,
				menu: [
						{
						to: '/school-time',
						label: 'School Time',
						icon: mdiAvTimer
					},
					{
						to: '/study-time',
						label: 'Study Time',
						icon: mdiAvTimer
					},
					{
						to: '/schedule',
						label: 'Schedule',
						icon: mdiTimetable
					},
					{
						to: '/extracuricular-schedule',
						label: 'Extracuricular Schedule',
						icon: mdiTimetable
					},
					{
						to: '/calendar',
						label: 'Calendar',
						icon: mdiCalendarMonth
					}
				]
			},
			{
				label: 'School Events',
				to: '/school-events',
				icon: mdiCalendar
			},
			{
				label: 'Attendance',
				subLabel: 'Submenus Attendance',
				icon: mdiAccountArrowLeft,
				menu: [
					{
						to: '/regular-subject-attendance',
						label: 'Regular Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/parallel-subject',
						label: 'Parallel Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/report-attendance-daily',
						label: 'Daily Attendance Report',
						icon: mdiAccountAlert
					},
					{
						to: '/summary-report',
						label: 'Summary Report',
						icon: mdiAccountAlert
					},
					{
						to: '/assignment-special',
						label: 'Special Assignment',
						icon: mdiBusDoubleDecker
					}
				]
			},
			{
				label: 'Subject Assessment',
				subLabel: 'Submenus Subject Assessment',
				icon: mdiSchool,
				menu: [
					{
						to: '/lesson-assessment-regular',
						label: 'Regular',
						icon: mdiSchool
					},
					{
						to: '/lesson-assessment-parallel',
						label: 'Parallel',
						icon: mdiSchool
					},
					{
						to: '/ledger-homeroom-attidude',
						label: 'Homeroom Ledger Attidude',
						icon: mdiSchool
					},
					{
						to: '/ledger-homeroom-teacher',
						label: 'Homeroom Ledger',
						icon: mdiSchool
					},
					{
						to: '/extracuricular-score',
						label: 'Extracuricular Score',
						icon: mdiSchool
					}
				]
			},
			{
				label: 'Raport',
				to: '/student-raport',
				icon: mdiSchool
			},
			{
				label: 'Settings',
				subLabel: 'Submenus Settings',
				icon: mdiCog,
				menu: [
					{
						to: '/schoolidentity',
						label: 'School Identity',
						icon: mdiSchool
					},
					{
						to: '/branch',
						label: 'Branch',
						icon: mdiWatermark
					},
					{
						to: '/users',
						label: 'Users',
						icon: mdiAccount
					},
					{
						to: '/active-docmag',
						label: 'Activate Management',
						icon: mdiFolderCheckOutline
					},
					{
						to: '/unapprove-mechanism',
						label: 'Unapprove Mechanism',
						icon: mdiAccountWrench
					},
					{
						to: '/settingattendance',
						label: 'Setting Attendance',
						icon: mdiPen
					},
					{
						to: '/settingspeed',
						label: 'Chart & Analysis Setting',
						icon: mdiChartBar
					},
					{
						to: '/settingtimeout',
						label: 'Setting Major & Cross Major',
						icon: mdiTimelineClockOutline
					},
					{
						to: '/settingextracuricular',
						label: 'Setting Extracuricular',
						icon: mdiTimelineClockOutline
					},
					{
						to: '/settingmodule',
						label: 'Setting Module',
						icon: mdiBookOpenPageVariant
					},
					{
						to: '/template-announcement',
						label: 'Template Announcement',
						icon: mdiSchool
					}
				]
			}
]
export default menuAcademicAll
